export const normalizeLineUserIds = value => {
  const source = Array.isArray(value) ? value : [];
  return source.reduce((collected, item) => {
    const normalized = String(item || '').trim();
    return normalized && !collected.includes(normalized) ? [...collected, normalized] : collected;
  }, []);
};

export const getLineConnectionState = status => {
  const lineUserIds = normalizeLineUserIds(status?.lineUserIds);
  const linked = status?.linked === true && lineUserIds.length > 0;
  const verified = status?.verified === true;

  return {
    linked,
    verified,
    connected: linked && verified,
    lineUserIds,
  };
};

export const isLineAccountConnected = status => getLineConnectionState(status).connected;

export const shouldPromptForLineConnect = status => {
  return (
    !!status &&
    !isLineAccountConnected(status) &&
    status.lineDoNotAskAgain !== true &&
    status.shouldPrompt !== false
  );
};
